import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Videocard from 'components/items/videocard';
import AdCaller from 'helpers/ads/adCaller';
import _get from 'lodash.get';
import s from './Topvideos.scss';

class Topvideos extends React.Component {
  render() {
    const videoarray = this.props.data ? this.props.data.items : [];
    if (videoarray.length > 1) {
      return (
        <div className="related-stories">
          <div className={`${s.box1} ${s.ads}`}>
            <AdCaller
              data={{
                adCode:
                  '/7176/TOI/TOI_Videos/TOI_Videos_News/TOI_ROS_ATF_VID_NWS_300',
                size: [[300, 250], [300, 600]],
                divId: 'div-gpt-ad-1473922612256-0-123',
              }}
            />
          </div>
          <div className={s.titleSection}>
            <h2 className={s.title}>
              <a href="#" className={s.nonClickableHeading}>
                <span>Top</span> Videos
              </a>
            </h2>
          </div>
          <div className={s.box1}>
            {videoarray.map(item => (
              <Videocard
                theme="topvideo_horizontal"
                data={item}
                watchLater={
                  !!_get(this.props.watchLaterObj, item.id, undefined)
                }
                activityId={this.props.getWatchLaterActivityId(
                  _get(this.props.watchLaterObj, item.id, undefined),
                )}
              />
            ))}
          </div>
        </div>
      );
    }
    return null;
  }
}

Topvideos.propTypes = {
  data: PropTypes.element.isRequired,
  watchLaterObj: PropTypes.shape({}),
  getWatchLaterActivityId: PropTypes.shape({}),
};
Topvideos.defaultProps = {
  watchLaterObj: {},
  getWatchLaterActivityId: {},
};
const mapStateToProps = state => ({
  data: state.topvideos.data,
});

export default connect(mapStateToProps, undefined)(Topvideos);
